import getElapsedTime from '../utils/elapsed-time';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  startTimer,
  stopTimer,
  resetTimer
} from '../actions/index';

import {
  Button,
  Glyphicon,
  Jumbotron
} from '../../node_modules/react-bootstrap/lib/';

import {
  clearTimerState
} from '../utils/timerPersistence';


class Timer extends Component {

  componentDidMount() {

    this.interval =
      setInterval(
        this.forceUpdate.bind(this),
        this.props.updateInterval
      );
  }


  componentWillUnmount() {

    clearInterval(
      this.interval
    );
  }


  /*
   * =======================================================
   * RESET COMPLETO
   * =======================================================
   *
   * RESET significa:
   *
   * - limpiar el Timer en Redux
   * - limpiar los tiempos/estado asociados al reset actual
   * - eliminar la copia persistida localmente
   *
   * STOP NO elimina la persistencia.
   */
  handleReset = () => {

    clearTimerState();

    this.props.resetTimer();
  };


  render() {

    const {
      baseTime,
      startedAt,
      stoppedAt,
      last
    } = this.props;


    const elapsed =
      getElapsedTime(
        baseTime,
        startedAt,
        stoppedAt
      );


    /*
     * Si no quedan atletas pendientes
     * detenemos automáticamente el Timer.
     *
     * Esto es STOP, no RESET.
     *
     * Por lo tanto NO se elimina
     * la persistencia local.
     */
    if (
      !stoppedAt &&
      last === 0
    ) {

      setTimeout(
        () => {

          this.props.stopTimer();

        },
        1
      );
    }


    return (

      <div>

        <Jumbotron>

          <div align="center">

            <kbd>

              {
                elapsed === 0
                  ? "00:00:00"
                  : elapsed
              }

            </kbd>

          </div>

        </Jumbotron>


        <div>

          <Button
            bsStyle="success"

            disabled={
              startedAt > 0
            }

            onClick={() =>
              this.props.startTimer(
                elapsed
              )
            }
          >

            <Glyphicon
              glyph="play"
            />

            {' '}

            Iniciar

          </Button>

          &nbsp;


          <Button
            bsStyle="danger"

            disabled={
              stoppedAt > 0
            }

            onClick={() =>
              this.props.stopTimer()
            }
          >

            <Glyphicon
              glyph="stop"
            />

            {' '}

            Detener

          </Button>

          &nbsp;


          <Button
            bsStyle="info"

            disabled={
              !(
                startedAt &&
                stoppedAt
              )
            }

            onClick={
              this.handleReset
            }
          >

            <Glyphicon
              glyph="eject"
            />

            {' '}

            Reset

          </Button>

        </div>

      </div>
    );
  }
}


/*
 * =========================================================
 * REDUX ACTIONS
 * =========================================================
 */
function mapDispatchToProps(
  dispatch
) {

  return bindActionCreators(
    {
      startTimer,
      stopTimer,
      resetTimer
    },
    dispatch
  );
}


/*
 * =========================================================
 * REDUX STATE
 * =========================================================
 */
function mapStateToProps(
  state
) {

  const {
    startedAt,
    stoppedAt,
    baseTime
  } =
    state.reducerTimer;


  const {
    last
  } =
    state.reducerRegisterTime;


  return {

    startedAt,

    stoppedAt,

    baseTime,

    last
  };
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  Timer
);



// WEBPACK FOOTER //
// ./src/containers/timer.js